<template>
  <div class="header-subpage">
    <div v-if="navigationData" class="ds-margin-bottom-48">
      <DsLinkBack
        v-if="!hasBreadcrumbs"
        :url="navigationData.url"
        :text="navigationData.text || navigationData.title"
      />
      <DsBreadcrumbs
        v-else
        :crumbs="navigationData"
      />
    </div>
    <h1 class="ds-heading-xlarge ds-margin-y-12 ds-md-margin-y-24">
      {{ title }}
    </h1>
    <RichText
      v-if="richText"
      :data="richText"
      class="ds-text-medium"
    />
    <p
      v-if="text"
      class="ds-text-medium"
    >
      {{ text }}
    </p>
    <div
      v-if="$slots.extraContent"
      class="ds-margin-top-24 ds-md-margin-top-48"
    >
      <slot name="extraContent" />
    </div>
  </div>
</template>
<script setup>
import { DsLinkBack, DsBreadcrumbs } from 'awds'

defineOptions({
  name: 'HeaderSubpage'
})

const props = defineProps({
  navigationData: {
    type: [Object, Array, null],
    validator: (data) => {
      if (!Array.isArray(data)) {
        return ['text', 'url'].every(key => key in data)
      }

      return data.every((obj, index, arr) => {
        if (index === arr.length - 1) {
          return 'title' in obj
        }
        return ['title', 'url'].every(key => key in obj)
      })
    },
    default: null
  },
  title: {
    type: String,
    required: true
  },
  richText: {
    type: Object,
    default: null
  },
  text: {
    type: String,
    default: ''
  }
})

const hasBreadcrumbs = computed(() => Array.isArray(props.navigationData))
</script>
